import { Languages } from 'types/enums';

export const defaultLocale = Languages.EN;
